import React, { forwardRef } from 'react';

import { makeStyles } from '@mui/styles';
import { Box, Typography, IconButton } from '@mui/material';
import { ExternalLinkIcon } from '../../../components/icons';

const useStyles = makeStyles(() => ({
  menu: {
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
  },
  headUsername: {
    color: 'white',
    fontSize: '0.75rem',
    marginRight: '0.25rem',
    lineHeight: '1rem',
    cursor: 'default',
  },
  appButton: {
    padding: '4px',
  },
}));

const AppButton = ({ username, onClick }, ref) => {
  const styles = useStyles();

  return (
    <Box className={styles.menu}>
      <Typography className={styles.headUsername}>{username}</Typography>
      <IconButton
        onClick={onClick}
        data-testid="app-menu-button"
        className={styles.appButton}
      >
        <Box ref={ref}>
          <ExternalLinkIcon />
        </Box>
      </IconButton>
    </Box>
  );
};

export default forwardRef(AppButton);
